export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function getFetchErrorResponse(
  error: unknown
): Record<string, unknown> | null {
  if (!isRecord(error) || !isRecord(error.response)) {
    return null
  }

  return error.response
}

export function getFetchErrorStatus(error: unknown): number | undefined {
  const response = getFetchErrorResponse(error)
  const status = response?.status

  return typeof status === 'number' ? status : undefined
}

export function getFetchErrorData(error: unknown): unknown {
  const response = getFetchErrorResponse(error)
  return response?._data
}

function getObjectMessage(payload: Record<string, unknown>): string {
  const candidate =
    payload.message ??
    payload.error ??
    payload.msg ??
    payload.detail ??
    payload.title ??
    payload.reason

  return typeof candidate === 'string' ? candidate : ''
}

function extractDetailMessage(detail: unknown): string {
  if (typeof detail === 'string') {
    return detail
  }

  if (Array.isArray(detail)) {
    const first = detail[0]
    if (typeof first === 'string') {
      return first
    }
    if (isRecord(first)) {
      return getObjectMessage(first) || ''
    }
  }

  if (isRecord(detail)) {
    return getObjectMessage(detail)
  }

  return ''
}

export function extractPayloadMessage(payload: unknown): string {
  if (typeof payload === 'string') {
    return payload
  }

  if (Array.isArray(payload)) {
    return extractDetailMessage(payload)
  }

  if (!isRecord(payload)) {
    return ''
  }

  return extractDetailMessage(payload.detail) || getObjectMessage(payload)
}
